import gsap from 'gsap';

export default function fMenuToggle() {
    const oTriggerOpen = document.querySelector('.js-menu-open');
    const oTriggerClose = document.querySelector('.js-menu-close');
    const oMenu = document.querySelector('.js-menu');
    const aMenuItems = [].slice.call(oMenu.querySelectorAll('.header__nav__item'));
    const aMenuTitles = [].slice.call(oMenu.querySelectorAll('.header__nav__title'));
    const aMenuLinks = [].slice.call(oMenu.querySelectorAll('.header__mobile__link'));
    const aStaggerItems = aMenuItems.concat(aMenuTitles, aMenuLinks);

    if (!oTriggerOpen && oTriggerClose && oMenu && aStaggerItems) return;

    const oTimeline = gsap.timeline({
        paused: true
    }).to(oMenu, 0.8, {
        pointerEvents: 'all',
        autoAlpha: 1
    }).to(aMenuItems, 1, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.08
    }).to(aMenuTitles, 1, {
        autoAlpha: 0.3,
        stagger: 0.08
    }, (aMenuItems.length * 0.15)).to(aMenuLinks, 1, {
        autoAlpha: 1,
        stagger: 0.08
    }, (aMenuItems.length * 0.15));

    gsap.defaults({ ease: 'quart.intOut' });

    oTriggerOpen.addEventListener('click', event => {
        event.preventDefault();

        oTimeline.timeScale(2.75).play();
    });

    oTriggerClose.addEventListener('click', event => {
        event.preventDefault();

        oTimeline.timeScale(4).reverse();
    });
}
